import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,Modal,Button, ControlLabel, Checkbox, FormControl} from 'react-bootstrap';
 import moment   from 'moment'
import config from  '../../../config';
import formatNumbers  from 'util/formatNumbers';
import Datetime from 'react-datetime'
import json2csv   from 'json2csv'
 import Select   from 'react-select'
import async  from 'async';
  import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [
     {label: 'Title', value:'ProductName'},
     {label: 'Base price', value:'BasePrice'},
     {label: 'Shopify listing price', value:'ShopifyListingPrice'},
      {label: 'Seller price', value:'OriginalSellerPrice'},
     {label: 'SKU', value:'SKU'},
     {label: 'Create date', value:'createdAt'},
     {label: 'Last updated', value:'updatedAt'},
     {label: 'Location', value:'Markets.0.MarketName'},
     {label: 'Original url', value:'OriginalUrl'},
     {label: 'ShopifyProductID', value:'ShopifyProductID'},
     {label: 'Product Payout', value:'Payout'},
     {label: 'Tags', value:'ProductTags'},
     {label: 'Age range', value:'ProductAgeRange'},
     {label: 'Available Quantity', value:'ProductVariants.0.Quantity'},
     {label: 'Sold Quantity', value:'SoldQuantity'},
     {label: 'Product Payout', value:'Payout'},
     {label: 'Seller Location', value:'SellerID.MarketName'},
     {label: 'Original price', value:'OriginalPrice'},
     {label: 'Shopify product link', value:'ShopifyProductLink'},
     {label: 'Condition', value:'Condition'},
     {label: 'Original description', value:'OriginalDescription'},
     {label: 'Seller display name', value:'SellerID.DisplayName'},
     {label: 'Days To Sell', value:'FirstProductTransactionRecord.SaleData.TimeToSell'},
     {label: 'COGS', value:'COGS'},
     {label: 'TotalCOGS', value:'TotalCOGS'},
     {label: 'Created by', value:'CreatedBy'},
     {label: 'Seller email', value:'UserID.email'},
     {label: 'Deleted', value:'Deleted'},
     {label: 'Inventory Ownership', value:'SellerID.InventoryOwnership'},
     {label: 'TrackingNumbers', value:'TrackingNumbers'},
     {label: 'Pallet Creation Date', value:'PalletCreationDate'},
     {label: 'Shopify shipping markup', value:'ShopifyShippingMarkup'},

   //  {label: 'Weight', value:'ProductVariants.0.OriginalProductData.Weight'},
  //   {label: 'Weight Unit', value:'ProductVariants.0.OriginalProductData.WeightUnit'},

 ]
var reportFieldsForProductItems =_.reject(allReportFieldList, field=>{
    return _.includes(['SoldQuantity','COGS', 'TotalCOGS','CreatedBy','Deleted','TrackingNumbers'],field.value)
}).concat([
    {label: 'Item SKU', value:'ProductItems.ProductItemSKU'},
    {label: 'Item Location', value:'ProductItems.ProductItemLocation'},
    {label: 'Item Quantity', value:'ProductItems.ProductItemQuantity'},
    {label: 'Item Status', value:'ProductItems.ProductItemStatus'},
 ])
var actionsList = [
    {'label':'Update COGs for seller\'s products', value:'UpdateCOGSForSellerProducts',
        endpoint:'/process-action'},
    {'label':'Update COGs for seller\'s products', value:'UpdateCOGSForSellerProducts',
        endpoint:'/process-action'},
    {'label':'Send warehouse pickup reminder', value:'SendWarehousePickupSMSReminder' },
    {'label':'Send today pickup reminder', value:'SendPickupTodayReminder' },
    {'label':'Send warehouse pickup cancellation notification', value:'SendWarehousePickupCancellationNotification' },
    {'label':'Send service two days before reminder', value:'SendPickupSMSReminder' },
    {'label':'Send service cancellation notification', value:'SendServiceReminderAnswerNotReceived' },
    {'label':'Sync comments from Shopify orders', value:'CheckCommentsInShopifyOrders' },
    {'label':'Add "over120" tag to products', value:'AddOver120TagToProducts'  },
    {'label':'Move product to children\'s hospital collection', value:'MoveProductsToChildrenHospitalCollection'  },
    {'label':'Set transactions as Forfeited', value:'SetTransactionsAsForfeited' },
    {'label':'Daily KPI Report', value:'DailyKPIReport' },
    {'label':'Weekly KPI Report', value:'WeeklyKPIReport' },
    {'label':'Run all price reduce scripts (from 20 days)', value:'RunAllReducePriceScripts'},
    {'label':'Import locations priority map', value:'ImportWarehouseLocationsPriorityMap', endpoint:'/process-action'},
    {'label':'Update locations priority in all transactions', value:'UpdateWarehouseLocationsPriorityInTransactions', endpoint:'/process-action'},
    {'label':'Update products for inventory transfer', value:'UpdateProductsForInventoryTransfer', endpoint:'/process-action'},

]

var allSyncingReportFields = [
    {label: 'Title', value:'ProductName'},
    {label: 'Seller display name', value:'SellerID.DisplayName'},
   // {label:'Published in Shopify', value: 'PublishedInShopify' },
  //  {label:'Published in Local DB' , value: 'PublishedInLocalDB'},
    {label:'Quantity in Shopify', value: 'QuantityInShopify' },
    { label:'Quantity in Local DB', value: 'QuantityInLocalDB'},
    { label:'Not exist in Shopify', value: 'DoNotExistInShopify'},
    { label:'Not exist in Local DB',value: 'DoNotExistInLocalDB'},
    { label:'Do not include Age group tags in Shopify', value: 'ShopifyProductNotIncludeAgeGroupTags'},
    { label:'Do not include Age group tags in Local DB', value: 'LocalProductNotIncludeAgeGroupTags'},
    {label: 'Deleted in LocalDB and exists in Shopify', value:'DeletedInLocalDBAndExistsInShopify'},
    {label: 'Create date', value:'createdAt'},
    {label: 'Last updated', value:'updatedAt'},
    {label: 'Shopify product link', value:'ShopifyProductLink'},
   // {label: 'Published in Shopify, not in local DB IDs', value:'PublishedInShopifyNotInLocalDBIDs'},
    ]
var allLocationDataUpdateReportFields = [
    {label: 'Title', value:'ProductName'},
    {label: 'Seller display name', value:'SellerID.DisplayName'},
    {label: 'Previous Location', value:'previousLocation'},
    {label: 'New location', value:'newLocation'},
    {label: 'Location Updated At', value:'locationUpdatedAt'},
    {label: 'Location Updated By', value:'locationUpdatedBy'},
    {label: 'Shopify product link', value:'ShopifyProductLink'},
    {label: 'Change log', value:'ChangeLog'},    ]
export default class AdminProductActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            reducePriceValue:10,
            addNewTagValue:'',
            assignGBGProductValue:'',
            selectedAction:'',
            foundGBGProductsList:[],
            updateProductModalVisible:false,
            showBulkUpdateErrorsModal:false,
            recordsNotUpdated:[],
            pending: false,
            additionalData:{},
             currentBulkUpdateAction:'',
              syncingReportFields:[
                {label: 'Title', value:'ProductName'},
                {label: 'Seller display name', value:'SellerID.DisplayName'},
               // {label:'Published in Shopify', value: 'PublishedInShopify' },
              //  {label:'Published in Local DB' , value: 'PublishedInLocalDB'},
                {label:'Quantity in Shopify', value: 'QuantityInShopify' },
                { label:'Quantity in Local DB', value: 'QuantityInLocalDB'},
                { label:'Not exist in Shopify', value: 'DoNotExistInShopify'},
                { label:'Not exist in Local DB',value: 'DoNotExistInLocalDB'},
                {label: 'Deleted in LocalDB and exists in Shopify', value:'DeletedInLocalDBAndExistsInShopify'},
                {label: 'Shopify product link', value:'ShopifyProductLink'},
             ],
            reportFields:_.reject(allReportFieldList, item=>{
                return _.includes(['TrackingNumbers','PalletCreationDate', 'ShopifyShippingMarkup'], item.value);
                }),
            locationDataUpdateReportFields: allLocationDataUpdateReportFields
         };
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
        // this.bulkUpdateActionsMap = {
        //     'reducePrice':{
        //         modalButtonLabel: 'Reduce Price'
        //      },
        //     'addNewTag':{
        //         modalButtonLabel: 'Add New Tag'
        //     }
        // }
    };


    componentWillReceiveProps(nextProps) {


        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
         }
    }

    fetchAdditionalData() {
        var self = this
        this.setState({additionalData:{}})
        this.props.getAggregatedData({additionalDataFields: this.state.additionalDataFields}).then(function (results) {
            var additionalData = {}
            _.forEach(self.state.additionalDataFields, function (fieldData) {
                var foundItem = _.find(results, function (data, fieldName) {
                    console.log('fieldName', fieldName, fieldData);
                    return fieldName == fieldData.value
                })
                if (_.get(foundItem, 'data.0')) {
                    additionalData[fieldData.value] = fieldData.format(_.get(foundItem, 'data.0.total'))
                }
            })
            console.log('additionalData', additionalData);
            self.setState({additionalData: additionalData})
        })
    }
    bulkUpdateSelectedProducts() {
         var methodData = {
             "endpoint": "/products_update",
            'type':'post',
            messageData: {'#1#': 'Products'},
            messageCode : 'recordsUpdated'
         };
        var self = this;
        self.setState({ currentBulkUpdateAction:'', pending:true, updateProductModalVisible:false})
         this.props.makeRequest({'products':this.props.adminProducts.selectedProducts,
             type:this.state.currentBulkUpdateAction,
             data:{ [this.state.currentBulkUpdateAction+'Value'] : this.state[this.state.currentBulkUpdateAction + 'Value']} }, methodData).then(response => {
            console.log('response.data',response.data );
                 self.props.search({doNotClearSelectedProducts:true});
              if (_.find(response.data, function (productUpdateResult) {
                     return productUpdateResult.error
                 })) {
                 this.showBulkUpdateErrorsModal(response.data);
             }
             self.setState({  pending:false })
        }).catch(error => {
            console.log('error', error );
             self.setState({  pending:false })
         });
    }
    prepareActionData(){
        var actionData = {}
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerProducts':
            if (_.get(this.state, 'selectedSeller.value')){
                actionData.SellerID = this.state.selectedSeller.value
            }else{
                actionData.error = {
                    'messageType': 'warning',
                    'messageCode': 'Please, select seller'
                }
            }
            case  'ImportWarehouseLocationsPriorityMap':
                if (_.get(this.state, 'MarketName')){
                actionData.MarketName = this.state.MarketName
            }else{
                actionData.error = {
                    'messageType': 'warning',
                    'messageCode': 'Please, select location'
                }
            }
                if (_.get(this.state, 'warehouseLocationsFileUrl')){
                    actionData.warehouseLocationsFileUrl = this.state.warehouseLocationsFileUrl
                }else{
                    actionData.error = {
                        'messageType': 'warning',
                        'messageCode': 'Please, insert file URL'
                    }
                }
            break;
            case  'RunAllReducePriceScripts':
                actionData.waitForResponse = true /* to avoid Exceeded 4 calls per second for api client. Reduce request rates to resume uninterrupted service and process each price reduce script in series */
                break;
            case  'UpdateWarehouseLocationsPriorityInTransactions':
                if (_.get(this.state, 'MarketName')){
                    actionData.MarketName = this.state.MarketName
                }else{
                    actionData.error = {
                        'messageType': 'warning',
                        'messageCode': 'Please, select location'
                    }
                }
                break;
            case  'WeeklyKPIReport':
                actionData.Markets =_.map( config.marketsList, 'value')
                break;
            case  'DailyKPIReport':
                actionData.Markets =_.map( config.marketsList, 'value')

                break;
            default:
                break
        }
        return  actionData
    }
    displayAdditionalRunActionsInputs(){
        switch (this.state.selectedAction) {
            case  'UpdateCOGSForSellerProducts':
            return <Col xs={12}  className="top10">
                <Select
                    tabIndex="0"

                    placeholder="Seller"
                    clearable={false}
                    options={this.allSellersOptionsList}
                    onChange={ (option)=>{
                        console.log('option', option  );
                        this.setState({'selectedSeller': option} )}
                    }
                    value={this.state.selectedSeller}
                />
            </Col>

            break;
            case  'ImportWarehouseLocationsPriorityMap':
                return <Col xs={12}  className="top10">
                    <Select
                        tabIndex="0"
                         clearable={false}
                        placeholder="Location"
                        options={   _.map(config.warehouseData, item => {
                            return {value: item.MarketName, label: item.MarketName}
                        })}
                        onChange={(option)=>{
                            this.setState({'MarketName': option.value}, function () {

                            });
                        }}
                        value={this.state.MarketName}
                    />
                    <div>
                        <ControlLabel>Google sheet file url</ControlLabel>
                        <FormControl type="text"

                                     onChange={(e) =>{

                                         this.setState({
                                             'warehouseLocationsFileUrl': e.target.value
                                         } )

                                     }}
                                     value={this.state.warehouseLocationsFileUrl }
                                     placeholder=""/>
                    </div>
                </Col>

                break;
            case  'UpdateWarehouseLocationsPriorityInTransactions':
                return <Col xs={12}  className="top10">
                    <Select
                        tabIndex="0"
                        clearable={false}
                        placeholder="Location"
                        options={   _.map(config.warehouseData, item => {
                            return {value: item.MarketName, label: item.MarketName}
                        })}
                        onChange={(option)=>{
                            this.setState({'MarketName': option.value}, function () {

                            });
                        }}
                        value={this.state.MarketName}
                    />

                </Col>

                break;
            default:
                return null

        }
    }
    showBulkUpdateErrorsModal(productsNotUpdated){
        var recordsNotUpdated = productsNotUpdated.filter(item => {
            return item.error
        });

        this.setState({
            showBulkUpdateErrorsModal: true,
            recordsNotUpdated: recordsNotUpdated,
            updateProductModalVisible:false,
         })
    }
    downloadReportForProducts(){
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        },    functionsToCall = {}, self  = this;
     
        self.setState({  pending:true })
        let params = {'products': this.props.adminProducts.selectedProducts,
            addFields:['Sellers','Users','CreatedBy','FirstProductTransactionRecord','SoldQuantity'],
            reportType:'products' }

        if(self.state.reportFields.find(item=>item.value == 'PalletCreationDate' )) {
            params.addFields.push('PalletCreationDate');
        }
        if(this.state.groupByProductItems) {
            params.groupByProductItems = true
            if (this.state.productItemsSearchText) {
                params.customSearchText = this.state.productItemsSearchText
                params.customSearchFields = ['ProductItems.ProductItemLocation', 'ProductItems.ProductItemSKU', 'ProductItems.ProductItemStatus']
            }
        }

        var {queryParams} = this.props.searchBox.getSearchParams();

        params =_.extend(params,_.pick(queryParams, ['fromSoldAt', 'toSoldAt']))
        if(this.state.productItemsCustomFilter){
            var customQueries =[]
            if (this.state.productItemsCustomFilter.value =='only_items_without_locations'){
                customQueries = [
                    {
                        "$match":  {
                            $or:  [
                                {'ProductItems.ProductItemLocation':{$exists:false}},
                               {"ProductItems.ProductItemLocation":'InTransit'},

                            ]
                        }
                    }]
            }else  if (this.state.productItemsCustomFilter.value =='only_items_with_locations'){
                customQueries = [
                    {
                        "$match":  {
                            $and:  [
                                {'ProductItems.ProductItemLocation':{$exists:true}},
                               {"ProductItems.ProductItemLocation":{$ne:'InTransit'}},

                            ]
                        }
                    }]
            }
            params.customQueries = JSON.stringify(customQueries)
        }


        functionsToCall['selectedProducts'] = function (done) {

            self.props.makeRequest(params, methodData).then(res => {
                done(null, res.data)
            }).catch(err => {
                done(err)
            });
        }

        console.log('queryParams', queryParams  );
        if (this.state.fromQuantityIncreasedTime && this.state.toQuantityIncreasedTime  ) {
            functionsToCall['productsWithQuantityIncreased'] = function (done) {
                var productsWithQuantityIncreasedParams = {
                 //   addFields:params.addFields,
                    reportType:params.reportType,
                    RecordActionForUser: 'product_creation',
                    fromQuantityIncreasedTime: self.state.fromQuantityIncreasedTime.toISOString(),
                    toQuantityIncreasedTime:  self.state.toQuantityIncreasedTime.toISOString(),
                }
                 self.props.makeRequest(productsWithQuantityIncreasedParams, methodData).then(res => {
                     var productsWithQuantityIncreased = []
                     console.log('to', moment(queryParams.to)  );
                     _.forEach( res.data, product => {
                         _.forEach(product.ChangeLog, function (item) {
                             if (_.get(item,'CustomData.RecordActionForUser') == 'product_creation'   && moment(_.get(item, 'Date')).isAfter(moment(productsWithQuantityIncreasedParams.fromQuantityIncreasedTime)) && moment(_.get(item, 'Date')).isBefore(moment(productsWithQuantityIncreasedParams.toQuantityIncreasedTime))){
                                 _.forEach(_.range(0,_.get(item,'CustomData.QuantityAdded',1)), index=>{
                                     productsWithQuantityIncreased.push({..._.pick(product, [
                                         'TrackingNumbers','Price','createdAt','updatedAt', 'SellerID','ShopifyProductID','CreatedBy','SKU','LocationInWarehouse']),QuantityIncreasedAt:moment(_.get(item, 'Date') ).format('YYYY-MM-DD HH:mm'), })
                                 })

                             }
                         })
                     })

                    done(null,productsWithQuantityIncreased)
                }).catch(err => {
                    done(err)
                });
            }
        }
        async.parallel(functionsToCall,
            function (err, responses) {
                if (err) {
                    self.setState({pending: false})
                    return;
                }
                self.setState({  pending:false })

           var fields = _.map(self.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
                if (self.state.fromQuantityIncreasedTime && self.state.toQuantityIncreasedTime  ) {
                     fields.push( {label: 'Quantity +1', value:'QuantityIncreasedAt'},)
                }
            console.log('responses', responses );
console.log('fields', fields  );
          //  var dataToExport = res.data.data; /* when export all Shopify products */
              var productsToExport = _.concat(responses.selectedProducts,_.get(responses,'productsWithQuantityIncreased',[]))
           var dataToExport  = _.map(productsToExport, function (product) {
               var customData = {};

               if ( _.find(fields, {value:  'ShopifyProductLink' })){
                   customData['ShopifyProductLink'] =config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]", product.ShopifyProductID)
                }

               if(fields.find(item=>item.value == 'PalletCreationDate' )) {
                   const {PalletRecord = {}} = product;
                   customData['PalletCreationDate'] = PalletRecord._id ? moment(PalletRecord.createdAt).format('YYYY-MM-DD HH:mm') : '';
               }

                product.CreatedBy=    _.startCase(_.get(product, ['MetaData', 'CreatedBy'], 'administrator')) + ' '  +   _.get(product, [ 'CreatedByUserID', 'email'], '')

               if (_.isUndefined(product.ChangeLog) || _.size(product.ChangeLog) ==0){
                   product.ChangeLog = '';
               }
               product.Price=  product.Price.toFixed(2);
               return {...product,
                   createdAt: moment(product.createdAt).format('YYYY-MM-DD HH:mm'),
                   updatedAt: moment(product.updatedAt).format('YYYY-MM-DD HH:mm'),
                   ...customData}
           })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

               var filename = "products_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }
            })

    }
    downloadReportForProducts2(){
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        var self  = this;
        self.setState({  pending:true })
        this.props.makeRequest({customReport:true, reportType:'products' }, methodData).then(res => {
            var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })
            console.log('res', fields );
            //  var dataToExport = res.data.data; /* when export all Shopify products */
            self.setState({  pending:false })
            var dataToExport  = _.map(res.data, function (product) {
                var customData = {};

                if (-1 !==_.find(fields, function (o) {
                        o.value ==  'ShopifyProductLink'
                    })){
                    customData['ShopifyProductLink'] =config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]", product.ShopifyProductID)
                }

                product.CreatedBy=    _.startCase(_.get(product, ['MetaData', 'CreatedBy'], 'administrator')) + ' '  +   _.get(product, [ 'CreatedByUserID', 'email'], '')

                if (_.isUndefined(product.ChangeLog) || _.size(product.ChangeLog) ==0){
                    product.ChangeLog = '';
                }
                product.Price=  product.Price.toFixed(2);
                return {...product,
                    createdAt: moment(product.createdAt).format('YYYY-MM-DD HH:mm'),
                    updatedAt: moment(product.updatedAt).format('YYYY-MM-DD HH:mm'),
                    ...customData}
            })
                 var csvData = json2csv.parse(dataToExport, {
                    fields: fields,
                })


            var filename = "products_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            self.setState({  pending:false })
            console.log('err', err );
        });
    }

    searchGBGProducts(searchText) {
        if (searchText == ''){
            return
        }
        var methodData = {
            "endpoint": "/gbg_products",
            'not_display_success_message': true,
         };


        return this.props.makeRequest({all:true, Type:'Public',   searchText}, methodData).then(res => {
             console.log('res', res.data.data );
             var GBGProductOptionList = _.sortBy(
                 _.map(res.data.data, function(element) {
                     return _.extend({}, element, {
                         label:element.Brand + ' ' + element.Model + ' '  + element.Category + ' ' + element.Subcategory + ' ' + element.GBGNote,
                         value:element._id,
                         GBGProduct: element})
                     }) , 'label')

              this.setState({foundGBGProductsList:GBGProductOptionList})
        }).catch(err => {
        });
    }
    downloadReport(params){
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        this.setState({pending:true})
        this.props.makeRequest({  reportType:params.reportType }, methodData).then(res => {
            this.setState({pending:false})

            var fields = _.map(params.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })
            console.log('res', fields );
            var dataToExport  = _.map(res.data.data, function (product) {
                var customData = {
                    createdAt:moment( product.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    updatedAt:moment( product.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
                };

                if ( _.find(fields, {value:  'ShopifyProductLink' }) && !_.includes(product.ShopifyProductID, 'temporary')){
                     customData['ShopifyProductLink'] =config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]", product.ShopifyProductID)
                }

                return {...product,...customData}
            })
            console.log('dataToExport', dataToExport ,fields );
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

            var filename =  params.reportType + "_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            this.setState({pending:false})
            console.log('err', err );
        });
    }

    downloadProductSyncReport(){
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        this.setState({pending:true})
        this.props.makeRequest({  reportType:'products_sync' }, methodData).then(res => {
            this.setState({pending:false})

            var fields = _.map(this.state.syncingReportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })
            console.log('res', fields );
            var dataToExport  = _.map(res.data.data, function (product) {
                var customData = {
                    createdAt:moment( product.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    updatedAt:moment( product.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
                };

                if (-1 !==_.find(fields, function (o) {o.value ==  'ShopifyProductLink' })){
                    customData['ShopifyProductLink'] =config.getEnvironment().shopify.productUrlTemplate.replace("[link_value]", product.ShopifyProductID)
                }

                return {...product,...customData}
            })
             var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

            var filename = "products_syncing_report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            this.setState({pending:false})
            console.log('err', err );
        });
    }
    handleDownloadComplete(){
        console.log(' handleDownloadComplete',true );
        this.setState({'downloadReport':false});
    }
    renderGBGProductOption (option) {
         if (option.GBGNote.length > 80) {
            var trimmedString = option.GBGNote.replace(/^(.{80}[^\s]*).*/, "$1") +  ' ...'
        } else{
            var trimmedString = option.GBGNote.replace(/^(.{80}[^\s]*).*/, "$1")
        }
        // trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))

        return (
            <div>
                <div className="green"  >{option.Brand}</div>
                <div  style={{color:'orange'}} >{option.Model}</div>
                <div>{option.Category}</div>
                <div>{option.Subcategory}</div>
                <div>{trimmedString}</div>
            </div>
         );
    }
    triggerSelectedAction(){
        var methodData = {
            "endpoint": _.get(_.find(actionsList, {value:this.state.selectedAction}), 'endpoint', "/run-server-process"),
            'type':'post',
         };
        var self = this;

        var additionalData = this.prepareActionData()
        if (additionalData.error){
            return this.props.displayMessage(additionalData.error);
        }
        var actionData = _.extend({'action':self.state.selectedAction  }, additionalData)
        self.setState({   pending:true })
        this.props.makeRequest(actionData, methodData).then(response => {
            self.setState({  pending:false })
            if (_.get(response, ['data', 'clientMessage'], '')){
                  this.props.displayMessage({
                     'messageCode':_.get(response, ['data', 'clientMessage'], '')
                });
            } else{
                var message ='Action processed'
                // if (_.includes(['UpdateWarehouseLocationsPriorityInProducts'],self.state.selectedAction)){
                //     message = 'Action started'
                // }
                return this.props.displayMessage({
                     'messageCode':message
                });
            }

        }).catch(error => {
            console.log('error', error );
            self.setState({  pending:false })
        });
    }

    render() {
         // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }

         return (
            <div className="action-block">

                <Tabs defaultActiveKey={'products_data'} id="productsActions" >
                        {/*unmountOnExit - do not render component until the tab is clicked*/}
                    <Tab eventKey={'products_data'} unmountOnExit={true} title="Data">
                        <Row className="show-grid">
                            <Col md={3} sm={6} xs={9} className="   top10">
                                    <Select
                                        tabIndex="0"
                                        multi
                                        selectedOptions
                                        clearable={true}
                                        placeholder="Additional data"
                                        options={ [
                                            {label: 'Price', value:'Price', format:(total)=>{
                                            return   formatNumbers.formatMoney(total)}
                                            },
                                            {label: 'Original Price', value:'OriginalPrice',format:(total)=>{
                                                return   formatNumbers.formatMoney(total)}
                                            },
                                           ]}
                                        onChange={ (selectedOptions) =>{
                                            var self = this
                                            this.setState({additionalDataFields:selectedOptions}, function() {
                                                this.setState({additionalData:{}})
                                                if (_.size(this.state.additionalDataFields)) {
                                                   this.fetchAdditionalData()
                                                }
                                            })
                                        }}
                                        //  filterOptions={filterOptions}
                                        value={this.state.additionalDataFields}
                                    />
                                </Col>
                            {/*<Col md={3} sm={6} xs={9} className="pleft0  top10">*/}
                                {/*<button className="btn btn-primary bg-red border-red" onClick={() => {*/}
                                    {/*var self = this*/}
                                 {/*this.resetAdditionalData()*/}
                                    {/*this.props.getAggregatedData({additionalDataFields:this.state.additionalDataFields}).then(function(results) {*/}
                                        {/*console.log('total field data', results );*/}
                                        {/*var additionalData ={}*/}
                                    {/*_.forEach(self.state.additionalDataFields, function(fieldData) {*/}
                                            {/*var foundItem = _.find(results, function(data, fieldName) {*/}
                                                {/*console.log('fieldName', fieldName  ,fieldData);*/}
                                                {/*return fieldName == fieldData.value*/}
                                            {/*})*/}
                                            {/*if (_.get(foundItem,'data.0')) {*/}
                                                {/*additionalData[fieldData.value] = fieldData.format(_.get(foundItem, 'data.0.total'))*/}
                                            {/*}*/}
                                        {/*})*/}
                                        {/*console.log('additionalData', additionalData  );*/}
                                        {/*self.setState({additionalData:additionalData})*/}
                                    {/*})*/}
                                {/*} }  disabled={!_.get(this.state,'additionalDataFields', []).length}*/}
                                        {/*type="button">*/}
                                    {/*Show Total*/}
                                {/*</button>*/}
                            {/*</Col>*/}
                            {_.get(this.state,'additionalData.Price','') !== '' &&
                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <div className='pull-left' style={{width: 80}}>
                                    <div className="text-center">Total Price</div>
                                    <div
                                        className="font-size-19 text-center purple top7">  {this.state.additionalData.Price}</div>
                                </div>
                            </Col>
                            }
                            {_.get(this.state,'additionalData.OriginalPrice','') !== '' &&
                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <div className='pull-left' style={{width: 120}}>
                                    <div className="text-center">Original Price</div>
                                    <div
                                        className="font-size-19 text-center purple top7">  {this.state.additionalData.OriginalPrice}</div>
                                </div>
                            </Col>
                            }
                        </Row>


                    </Tab>

                    {(_.isUndefined(this.props.location.query.PalletID)   && config.checkAccessRights.call(this,{ resources:[  'products_edit']})) &&

                    <Tab eventKey={'update_products'} unmountOnExit={true} title="Change">
                        <Row className="show-grid">
                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <Col xs={12} className="top10">
                                    <FormControl type="text"
                                                 defaultValue={this.state.reducePriceValue}
                                                 onChange={ (event) => this.setState({reducePriceValue: event.target.value})}
                                                 placeholder="Reduce price by"/>
                                </Col>
                                <Col xs={12} className="top10">
                                    <button className="btn btn-primary bg-red border-red" onClick={() => this.setState({
                                        updateProductModalVisible: true,
                                        modalTitleMessage: <span>Price for <span
                                            style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}
                                            will be reduced by {this.state.reducePriceValue} percent </span>,
                                        currentBulkUpdateAction: 'reducePrice',
                                    })}
                                            disabled={!this.props.adminProducts.selectedProducts.length}
                                            type="button">
                                        Reduce price
                                    </button>
                                </Col>
                            </Col>

                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <Col xs={12} className="top10">
                                    <FormControl type="text"
                                                 defaultValue={this.state.addNewTagValue}
                                                 onChange={ (event) => this.setState({addNewTagValue: event.target.value})}
                                                 placeholder="Tag"/>
                                </Col>
                                <Col xs={12} className="top10">
                                    <button className="btn btn-primary bg-red border-red" onClick={() => this.setState({
                                        updateProductModalVisible: true,
                                        currentBulkUpdateAction: 'addNewTag',
                                        modalTitleMessage: <span>Tag {this.state.addNewTagValue} will be added to <span
                                            style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}</span>,
                                    })}
                                            disabled={!this.props.adminProducts.selectedProducts.length || !this.state.addNewTagValue}
                                            type="button">
                                        Add tag
                                    </button>
                                </Col>
                            </Col>

                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <Col xs={12} className="top10">
                                    <Select
                                        tabIndex="0"
                                        clearable={true}
                                        placeholder="GBG Product"
                                        options={this.state.foundGBGProductsList}
                                        optionRenderer={this.renderGBGProductOption}
                                        onInputKeyDown={(e) => {
                                            switch (e.keyCode) {

                                                case 13: // ENTER
                                                    e.preventDefault();
                                                    this.searchGBGProducts(e.target.value);
                                                    break;
                                            }


                                        }}
                                        onChange={(option) => {
                                            console.log('option ', option);
                                            this.setState({
                                                assignGBGProductValue: option ? option.value : null,
                                            })
                                        }}
                                        value={this.state.assignGBGProductValue}
                                    />
                                </Col>
                                <Col xs={12} className="top10">
                                    <button className="btn btn-primary bg-red border-red" onClick={() => {
                                        var selectedGBGProduct = _.find(this.state.foundGBGProductsList, {'_id': this.state.assignGBGProductValue});
                                        if (!selectedGBGProduct) {
                                            return
                                        }
                                        this.setState({
                                            updateProductModalVisible: true,
                                            currentBulkUpdateAction: 'assignGBGProduct',
                                            modalTitleMessage: <span>GBG Product <span
                                                className="green">{_.get(selectedGBGProduct, ['GBGProduct', 'Brand'], '') + ' ' } </span><span
                                                style={{color: 'orange'}}> { _.get(selectedGBGProduct, ['GBGProduct', 'Model'], '')}</span> will be assigned to <span
                                                style={{color: '#ff2926'}}>{this.props.adminProducts.selectedProducts.length}</span> {this.props.adminProducts.selectedProducts.length == 1 ? 'product' : 'products'}</span>,
                                        })

                                    }}
                                            disabled={!this.props.adminProducts.selectedProducts.length || !this.state.assignGBGProductValue}
                                            type="button">
                                        Assign GBG Product
                                    </button>
                                </Col>
                            </Col>

                            {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&
                            <Col md={3} sm={6} xs={9} className="pleft0  top10">
                                <Col xs={12} className="top10">
                                    <Select
                                        tabIndex="0"
                                        clearable={true}
                                        placeholder="Action"
                                        options={actionsList}
                                        onChange={(option) => {
                                            this.setState({
                                                selectedAction: option ? option.value : null,
                                            })
                                        }}
                                        value={this.state.selectedAction}
                                    />
                                </Col>
                                <Col xs={12} className="top10">
                                    <button className="btn btn-primary bg-red border-red"
                                            onClick={this.triggerSelectedAction.bind(this)}
                                            disabled={!this.state.selectedAction || this.state.pending}
                                            type="button">
                                        Run action
                                    </button>
                                </Col>
                                {this.displayAdditionalRunActionsInputs()}
                            </Col>
                            }
                        </Row>


                    </Tab>
                    }
                    { config.checkAccessRights.call(this, {resources: ['products_full']}) &&
                    <Tab eventKey={'reports'} unmountOnExit={true} title="Reports">
                        <Row className="show-grid">
                            <Col md={6} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    value={this.state.reportFields}
                                />
                            </Col>
                            {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&
                            <Col md={3} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allSyncingReportFields}
                                    onChange={ (selectedOptions) => this.setState({'syncingReportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.syncingReportFields}
                                />
                            </Col>
                            }
                            {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&
                            <Col md={3} xs={6} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allLocationDataUpdateReportFields}
                                    onChange={ (selectedOptions) => this.setState({'locationDataUpdateReport': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.locationDataUpdateReportFields}
                                />
                            </Col>
                            }
                        </Row>
                        <Row>
                            <Col md={6} xs={6} className="top10">
                                <Row className=" ">
                                    <Col xs={12} md={6} className="top10  ">
                                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                                  onChange={(value) => {
                                                      this.setState({'fromQuantityIncreasedTime': value});
                                                  }
                                                  }
                                                  value={this.state.fromQuantityIncreasedTime}
                                                  inputProps={{placeholder: 'From +1'}}/>
                                    </Col>
                                    <Col  xs={12} md={6} className="top10  ">
                                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                                  onChange={(value) => this.setState({'toQuantityIncreasedTime': value})}
                                                  value={this.state.toQuantityIncreasedTime}
                                                  inputProps={{placeholder: 'To +1'}}/>
                                    </Col>
                                </Row>
                                <Row className=" top5">
                                    <Col xs={12} md={5} className="top10   ">
                                        <Checkbox style={{   }}
                                                  className="top10  "
                                                  onChange={(e) =>{
                                                      var dataToUpdate ={groupByProductItems: !this.state.groupByProductItems}
                                                      if (dataToUpdate.groupByProductItems){
                                                          dataToUpdate.reportFields =reportFieldsForProductItems
                                                      }else{
                                                          dataToUpdate.reportFields =allReportFieldList
                                                      }
                                                      this.setState(dataToUpdate)

                                                  }}
                                                  checked={this.state.groupByProductItems} inline><span className=" left5">Group by product items</span></Checkbox>
                                    </Col>
                                    {this.state.groupByProductItems &&
                                <Col xs={12} md={7} className=" top10 ">
                                    <FormControl type="text"
                                                 defaultValue={this.state.productItemsSearchText}

                                                 onChange={ (e) => {
                                                     this.setState({productItemsSearchText: e.target.value})
                                                 }}
                                                 placeholder="Search by location, status or SKU"/>
                                </Col>
                                }
                                    {this.state.groupByProductItems &&
                                    <Col xs={12} md={12} className=" top10 ">
                                        <Select
                                            tabIndex="0"

                                            placeholder=""
                                            clearable={false}
                                            options={[{value:'only_items_with_locations', label:'Show only items with locations and not in transit'},
                                                {value:'only_items_without_locations', label:'Show only items without locations or in transit'},
                                             ]}

                                            onChange={ (option)=>{
                                                 this.setState({'productItemsCustomFilter': option} )}
                                            }
                                            value={this.state.productItemsCustomFilter}
                                        />
                                    </Col>
                                    }
                                </Row>

                            </Col>
                            <Col md={6} xs={6} className="top10">
                            </Col>
                        </Row>
                        <Row>


                            <Col md={6} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={() => {
                                            var dataToUpdate = {reportFields: [...this.state.reportFields]}
                                            if (_.get(this.props.location.query, 'disposition')) {
                                                if (!_.find(this.state.reportFields, {value: 'Disposition'})) {
                                                    dataToUpdate.reportFields = _.concat(dataToUpdate.reportFields, [
                                                        {label: 'Disposition', value: 'Disposition'},
                                                        {label: 'Invoice cost', value: 'InvoiceCost'},
                                                        {label: 'TrackingNumbers', value: 'TrackingNumbers'}
                                                    ])
                                                }
                                            }
                                            this.setState(dataToUpdate, function () {
                                                this.downloadReportForProducts()
                                            })
                                        }}
                                        type="button">
                                    Download report
                                </button>
                            </Col>

                            {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&
                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ this.downloadProductSyncReport.bind(this)}
                                        type="button">
                                    Product syncing report
                                </button>
                            </Col>

                            }
                            {_.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), ['Ops Manager', 'Product Manager', 'Administrator'])) > 0 &&
                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ () => this.downloadReport({
                                            reportType: 'products_location_update',
                                            reportFields: this.state.locationDataUpdateReportFields
                                        })}
                                        type="button">
                                    Location data update report
                                </button>
                            </Col>
                            }
                        </Row>

                    </Tab>
                    }
                    </Tabs>
                 <Modal  show={this.state.updateProductModalVisible}
                         onHide={(e)=>this.setState({ currentBulkUpdateAction:'', updateProductModalVisible:false})}     >
                    <Modal.Header>
                        <Modal.Title>{this.state.modalTitleMessage}</Modal.Title>
                    </Modal.Header>

                    <Modal.Footer>
                        <Button onClick={(e)=>this.setState({ currentBulkUpdateAction:'', updateProductModalVisible:false})}>Cancel</Button>
                        <Button
                            disabled={this.state.pending}
                            onClick={(e)=>this.bulkUpdateSelectedProducts() }
                                bsStyle="primary">{ _.startCase(this.state.currentBulkUpdateAction)}</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showBulkUpdateErrorsModal}
                       onHide={() => this.setState({
                           showBulkUpdateErrorsModal: false
                       })}>
                    <Modal.Header closeButton>
                        <Modal.Title> {this.state.recordsNotUpdated.length}  {this.state.recordsNotUpdated.length == 1 ? 'product was ' : 'products were'} not updated.</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                                 <Row className="bot20">
                                    <Col md={12} sm={12} xs={12}
                                         style={{textAlign: 'justify'}}>
                                            <div className="bot10">
                                                Please, check email for update error details for the following {this.state.recordsNotUpdated.length == 1 ? 'product' : 'products'}:
                                            </div>
                                            {this.state.recordsNotUpdated.map( (updateProductErrorResult, i) => <div style={{
                                                 fontWeight: '500', marginTop:3,
                                             }} key={'x'+i}>{_.get(updateProductErrorResult, ['data', 'ShopifyProductID'], '') + ' ' + _.get(updateProductErrorResult, ['data', 'ProductName'], '')}</div> )}
                                     </Col>
                                </Row>
                         </div>
                    </Modal.Body>
                    <Modal.Footer>
                             <Row className="left0">
                                <Col md={12} sm={12} xs={12} className="pleft0">
                                    <Button className="pull-right btn right20 btn-default"
                                            type="button"
                                            onClick={() => this.setState({
                                                showBulkUpdateErrorsModal: false
                                            })}>
                                        OK
                                    </Button>
                                </Col>
                            </Row>
                     </Modal.Footer>
                </Modal>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
                </div >
        );

    }
}



